"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntroBox = exports.Image = exports.CoverBox = exports.AboutBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../../../StyledLayout");

var _constants = require("../../../../constants/constants");

/* eslint-disable max-len */
var themeTopNavHeight = _constants.adamsDimensions.themeTopNavHeight,
    desktopFooterOffset = _constants.adamsDimensions.desktopFooterOffset,
    mobileFooterOffset = _constants.adamsDimensions.mobileFooterOffset,
    typeThemeModalTitleHeight = _constants.adamsDimensions.typeThemeModalTitleHeight;
var AboutBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__AboutBox",
  componentId: "sc-6xl8e8-0"
})(["height:", ""], function (props) {
  var offset = props.isTabletPortrait ? desktopFooterOffset : mobileFooterOffset;
  var extraOffset = props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '';

  if (props.vh1) {
    return "calc(".concat(props.vh1 * 100, "px - ").concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ")};");
  }

  return "calc(100vh - ".concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ")};");
});
exports.AboutBox = AboutBox;
var CoverBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__CoverBox",
  componentId: "sc-6xl8e8-1"
})(["height:724px;overflow:hidden;margin-bottom:", ";width:100%;padding:0 ", ";@media (min-width:768px){width:656px;padding:0;}@media (min-width:1152px){width:512px;}@media (min-width:1440px){width:541px;}@media (min-width:1900px){width:580px;}"], function (props) {
  return props.isDesktopSmall ? '0' : '24px';
}, function (props) {
  return props.theme.spacingSm;
});
exports.CoverBox = CoverBox;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-6xl8e8-2"
})(["width:100%;height:100%;object-fit:cover;"]);

exports.Image = Image;
var IntroBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__IntroBox",
  componentId: "sc-6xl8e8-3"
})(["width:100%;padding:0 ", ";@media (min-width:768px){width:656px;padding:0;}@media (min-width:1152px){width:512px;}@media (min-width:1440px){width:541px;}@media (min-width:1900px){width:580px;}"], function (props) {
  return props.theme.spacingSm;
});
exports.IntroBox = IntroBox;